import React from 'react';
import { makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { FORM_COLORS } from '../constants';
import { CatalogOption } from '../types';

const useStyles = makeStyles(() => ({
  wrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  disabled: {
    opacity: 0.4,
    pointerEvents: 'none',
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 14px',
    border: `0.5px solid ${FORM_COLORS.border}`,
    borderRadius: 20,
    cursor: 'pointer',
    fontSize: 13,
    background: FORM_COLORS.white,
    color: FORM_COLORS.text,
    userSelect: 'none',
    transition: 'all .15s',
    fontFamily: 'inherit',
  },
  chipOn: {
    borderColor: FORM_COLORS.pink,
    background: FORM_COLORS.pinkLight,
    color: FORM_COLORS.pinkDark,
  },
  icon: {
    fontSize: 12,
    color: FORM_COLORS.pink,
  },
  empty: {
    fontSize: 12,
    color: FORM_COLORS.textSecondary,
  },
}));

interface ToggleChipsProps {
  options: CatalogOption[];
  selected: string[];
  onChange: (next: string[]) => void;
  /** Si es true, sólo se puede seleccionar una opción (radio). */
  single?: boolean;
  disabled?: boolean;
  emptyMessage?: string;
}

export const ToggleChips = ({
  options,
  selected,
  onChange,
  single,
  disabled,
  emptyMessage = 'Sin opciones disponibles',
}: ToggleChipsProps) => {
  const classes = useStyles();

  const handleToggle = (optionId: string) => {
    if (single) {
      onChange([optionId]);
      return;
    }
    if (selected.includes(optionId)) {
      onChange(selected.filter((item) => item !== optionId));
    } else {
      onChange([...selected, optionId]);
    }
  };

  if (!options.length) {
    return <span className={classes.empty}>{emptyMessage}</span>;
  }

  return (
    <div className={`${classes.wrap} ${disabled ? classes.disabled : ''}`}>
      {options.map((option) => {
        const isOn = selected.includes(option.id);
        return (
          <button
            type="button"
            key={option.id}
            className={`${classes.chip} ${isOn ? classes.chipOn : ''}`}
            onClick={() => handleToggle(option.id)}
          >
            {isOn && <CheckIcon className={classes.icon} />}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};
